import styled from '@emotion/styled';

import { Icon, tokens } from '@hotjar/hotsauce';
import { SlideInTop } from '@hotjar/webapp/utils/animations';

export const ListTitle = styled.div`
  ${tokens.text('subtitle2')};
  margin-bottom: ${tokens.spacer.x1};
`;

export const FeaturesContainer = styled.ul`
  animation: ${SlideInTop} 0.3s forwards;
  margin-bottom: 0;
  padding-left: 0;
`;

export const FeatureListItem = styled.li`
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  list-style: none;

  &:not(:last-of-type) {
    margin-bottom: ${tokens.spacer.x1};
  }
`;

export const StyledIcon = styled(Icon)`
  margin-left: ${tokens.spacer.x1};
`;
